
import PropTypes from 'prop-types'
import React from 'react'
import DisableBodyScroll from './DisableBodyScroll'
import ShowHide from './ShowHide'
import classnames from 'classnames'
import './FullscreenModal.css'

const FullscreenModal = props => {
  const classes = classnames({
    FullscreenModal: true,
    'FullscreenModal--showing': props.isShowing
  })

  return (
    <div className={classes}>
      <ShowHide show={props.isShowing}>
        <DisableBodyScroll />
      </ShowHide>

      {props.children}
    </div>
  )
}

FullscreenModal.propTypes = {
  children: PropTypes.oneOfType([ PropTypes.object, PropTypes.array ]).isRequired,
  isShowing: PropTypes.bool.isRequired
}

FullscreenModal.displayName = 'FullscreenModal'

export default FullscreenModal



// WEBPACK FOOTER //
// ./ui/FullscreenModal.js